import axios from "@/plugins/axios";

let url = "/api/v1/me/stocks/products";

export const products = {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
};

export default products;
